var m = require('mithril');
var Model = require('../../libs/Model');
var animations = require('../../libs/animations');
var formGroup = require('../../components/formGroup');
var discoveryModal = require('../discoveryModal');

var functionBlock = Object.create(Model);
  
functionBlock.name = 'Function Block';
functionBlock.url = 'functionblock';
functionBlock['@class'] = 'FunctionBlock';
functionBlock.fields = {
  parent: {
    hidden: true
  },
  name: {
    type: 'string',
    default: '',
    validators: {
      presence : true, 
      length: {minimum: 3, maximum: 128, default: ''},
    }
  },
  eesPath: {
    type: 'string',
    validators: {}
  },
};

functionBlock.actions = [
  {
    name: 'Discover',
    func: function (ctrl) {
      return discoveryModal.open(ctrl.record, ctrl.init);
    }
  }
];

functionBlock.initForm();

functionBlock.view = function () { 
  return  m('form', {role:'form'}, [
    functionBlock.errorView(),
    m(formGroup, [
      m('label', {for:'name-input'}, 'Name'),
      m('input.form-control', {
        id:'name-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){functionBlock.form.name(ev.target.value)},
        value: functionBlock.form.name(),
      })
    ]),
    m(formGroup, [
      m('label', {for:'eesPath-input'}, 'EES Path'),
      m('input.form-control', {
        id:'eesPath-input', 
        autocomplete: 'off',
        type:'text', 
        onchange: function(ev){functionBlock.form.eesPath(ev.target.value)},
        value: functionBlock.form.eesPath(),
      })
    ]),
  ])
}

module.exports = functionBlock;
